export const SearchKey = {
	searchDate: "search-date" as const,
} as const;
